import React from 'react';
import '../../styles/ErrorMessage.css';

interface ErrorMessageProps {
  message: string | Error;
  onRetry?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  const errorMessage = message instanceof Error ? message.message : message;
  
  return (
    <div className="error-message">
      <i className="fas fa-exclamation-circle"></i>
      <p>{errorMessage}</p>
      {onRetry && (
        <button className="btn-retry" onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
